function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import { getCustomCommands } from '@/actions/CommandActions';
import Table from '@/components/Table';
import AliasResponse from '@/components/AliasResponse';
import UserLevelTag from '@/components/UserLevelTag';
import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import TableHeading from '@/components/TableHeading';
import { getUserLevelValue } from '@/utils/userlevel';
import { useLimitQueryState, usePageQueryState, useSearchQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import { SortDirections } from '@/types/client';
import EmptyState from '@/components/EmptyState';
import useQueryState from '@/hooks/useQueryState';
import { FormattedMessage, useIntl } from 'react-intl';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { PublicChannelContext } from '../layouts/PublicChannelLayout';
import SearchInput from '../SearchInput';
import { useParams } from 'react-router';
import Pagination from '../Pagination';
import { Helmet } from 'react-helmet';
import { useDebounce } from 'use-debounce';
import { Table as MantineTable } from '@mantine/core';
import styles from './CommandsPublic.module.scss';
import Icon, { IconSizes } from '../Icon';
var HeadingKeys;
(function(HeadingKeys) {
    HeadingKeys["COMMAND"] = "command";
    HeadingKeys["MESSAGE"] = "message";
    HeadingKeys["USER_LEVEL"] = "userLevel";
})(HeadingKeys || (HeadingKeys = {}));
var _obj;
var SortFunctions = (_obj = {}, _define_property(_obj, "command", function(a, b) {
    return a.name.localeCompare(b.name);
}), _define_property(_obj, "message", function(a, b) {
    return a.message.localeCompare(b.message);
}), _define_property(_obj, "userLevel", function(a, b) {
    return getUserLevelValue(a.userLevel) - getUserLevelValue(b.userLevel);
}), _obj);
function CommandHeader(param) {
    var sortBy = param.sortBy, sortDirection = param.sortDirection, setSortDirection = param.setSortDirection, setSortBy = param.setSortBy;
    function handleSortChange(key, direction) {
        setSortDirection(direction);
        setSortBy(direction != null ? key : null);
    }
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                active: sortBy === "command",
                sort: sortDirection,
                setSort: function(sortDirection) {
                    return handleSortChange("command", sortDirection);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "9WyylR",
                    defaultMessage: "Command"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                active: sortBy === "message",
                sort: sortDirection,
                setSort: function(sortDirection) {
                    return handleSortChange("message", sortDirection);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "T7Ry38",
                    defaultMessage: "Message"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                alignRight: true,
                active: sortBy === "userLevel",
                sort: sortDirection,
                setSort: function(sortDirection) {
                    return handleSortChange("userLevel", sortDirection);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "hqByQG",
                    defaultMessage: "User-Level"
                })
            })
        ]
    });
}
var MemoizedCommandHeader = /*#__PURE__*/ React.memo(CommandHeader);
function CommandRow(param) {
    var command = param.command;
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.commandNameColumn,
                children: command.name
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.commandMessageColumn,
                children: /*#__PURE__*/ _jsx(AliasResponse, {
                    size: "sm",
                    alias: command.alias,
                    response: command.message
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.commandUserLevelColumn,
                children: /*#__PURE__*/ _jsx(UserLevelTag, {
                    userLevel: command.userLevel
                })
            })
        ]
    });
}
var MemoizedCommandRow = /*#__PURE__*/ React.memo(CommandRow);
function CommandsPublic() {
    var intl = useIntl();
    var username = useParams().username;
    var _useContext = useContext(PublicChannelContext), publicChannel = _useContext.channel;
    var _useState = _sliced_to_array(useState(null), 2), commands = _useState[0], setCommands = _useState[1];
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), sortDirection = _useSortDirectionQueryState[0], setSortDirection = _useSortDirectionQueryState[1];
    var _useQueryState = _sliced_to_array(useQueryState('sortBy', {
        defaultValue: "command"
    }), 2), sortBy = _useQueryState[0], setSortBy = _useQueryState[1];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), page = _usePageQueryState[0], setPage = _usePageQueryState[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), limit = _useLimitQueryState[0], setLimit = _useLimitQueryState[1];
    var _useSearchQueryState = _sliced_to_array(useSearchQueryState(), 2), search = _useSearchQueryState[0], setSearch = _useSearchQueryState[1];
    var _useDebounce = _sliced_to_array(useDebounce(search, 500), 1), debouncedSearch = _useDebounce[0];
    React.useEffect(function() {
        if (publicChannel == null) {
            return;
        }
        getCustomCommands(publicChannel._id).then(function(commands) {
            return setCommands(commands);
        }).catch(console.error);
    }, [
        publicChannel
    ]);
    var sortedCommands = React.useMemo(function() {
        var sortedCommands = commands;
        if (sortedCommands == null) {
            return null;
        }
        if (debouncedSearch.length > 0) {
            var normalizedQuery = debouncedSearch.toLowerCase();
            sortedCommands = sortedCommands.filter(function(command) {
                return command.name.toLowerCase().includes(normalizedQuery) || command.message.toLowerCase().includes(normalizedQuery);
            });
        }
        var sortFn = sortBy != null ? SortFunctions[sortBy] : null;
        if (sortFn == null) {
            return sortedCommands;
        }
        sortedCommands = _to_consumable_array(sortedCommands);
        return sortDirection === SortDirections.ASC ? sortedCommands.sort(sortFn) : sortedCommands.sort(function(a, b) {
            return -sortFn(a, b);
        });
    }, [
        commands,
        debouncedSearch,
        sortDirection,
        sortBy
    ]);
    var slicedCommands = React.useMemo(function() {
        if (sortedCommands == null) {
            return null;
        }
        return sortedCommands.slice(page * limit, (page + 1) * limit);
    }, [
        sortedCommands,
        page,
        limit
    ]);
    var _publicChannel_displayName, _publicChannel_displayName1, _publicChannel_displayName2;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "jUHQDE",
                    defaultMessage: [
                        {
                            type: 1,
                            value: "channelName"
                        },
                        {
                            type: 0,
                            value: "'s Commands"
                        }
                    ]
                }, {
                    channelName: (_publicChannel_displayName = publicChannel === null || publicChannel === void 0 ? void 0 : publicChannel.displayName) !== null && _publicChannel_displayName !== void 0 ? _publicChannel_displayName : username
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.buttonRow,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        subHeading: intl.formatMessage({
                            id: "IeGIgJ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Commands are used to trigger responses in chat"
                                }
                            ]
                        }),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "jUHQDE",
                            defaultMessage: "{channelName}'s Commands",
                            values: {
                                channelName: (_publicChannel_displayName1 = publicChannel === null || publicChannel === void 0 ? void 0 : publicChannel.displayName) !== null && _publicChannel_displayName1 !== void 0 ? _publicChannel_displayName1 : username
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(SearchInput, {
                        autoFocus: true,
                        search: search,
                        setSearch: setSearch,
                        placeholder: intl.formatMessage({
                            id: "HEjycM",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search commands..."
                                }
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: slicedCommands,
                extraData: [
                    (_publicChannel_displayName2 = publicChannel === null || publicChannel === void 0 ? void 0 : publicChannel.displayName) !== null && _publicChannel_displayName2 !== void 0 ? _publicChannel_displayName2 : username,
                    page,
                    limit,
                    sortDirection,
                    sortBy
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsx(MemoizedCommandHeader, {
                        sortBy: sortBy,
                        sortDirection: sortDirection,
                        setSortDirection: setSortDirection,
                        setSortBy: setSortBy
                    });
                },
                renderRow: function(command) {
                    return /*#__PURE__*/ _jsx(MemoizedCommandRow, {
                        command: command
                    });
                },
                renderEmptyState: function() {
                    var _publicChannel_displayName;
                    return /*#__PURE__*/ _jsx(EmptyState, {
                        title: intl.formatMessage({
                            id: "RxjQku",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "No Commands"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "4b4iLH",
                            defaultMessage: [
                                {
                                    type: 1,
                                    value: "channelName"
                                },
                                {
                                    type: 0,
                                    value: " has no custom commands"
                                }
                            ]
                        }, {
                            channelName: (_publicChannel_displayName = publicChannel === null || publicChannel === void 0 ? void 0 : publicChannel.displayName) !== null && _publicChannel_displayName !== void 0 ? _publicChannel_displayName : username
                        }),
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            icon: faMagicWandSparkles,
                            size: IconSizes.MD
                        })
                    });
                },
                renderFooter: function() {
                    var _sortedCommands_length;
                    return /*#__PURE__*/ _jsx(Pagination, {
                        limit: limit,
                        page: page,
                        total: (_sortedCommands_length = sortedCommands === null || sortedCommands === void 0 ? void 0 : sortedCommands.length) !== null && _sortedCommands_length !== void 0 ? _sortedCommands_length : 0,
                        setLimit: setLimit,
                        nextPage: function() {
                            return setPage(page + 1);
                        },
                        previousPage: function() {
                            return setPage(page - 1);
                        }
                    });
                }
            })
        ]
    });
}
export default CommandsPublic;
